import { createContext, useContext } from "react";
const AuthUserContext = createContext(null);
export const AuthUserProvider = AuthUserContext.Provider;
export const useAuthUser = () => {
    const user = useContext(AuthUserContext);
    if (!user)
        throw new Error("useAuthUser must be used within an AuthUserProvider");
    return user;
};
//# sourceMappingURL=index.js.map